import React from 'react';
import type { FC } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import EmojiAddIcon from '@atlaskit/icon/core/emoji-add';
import { ToolbarButton, ToolbarButtonGroup, ToolbarTooltip } from '@atlaskit/editor-toolbar';

import { useInlineReactionActions } from './inlineReactionStore.ts';

const messages = defineMessages({
	reactTooltip: {
		id: 'experiment-inline-reactions.inline-reaction.tooltip',
		defaultMessage: 'React',
		description: 'Tooltip for the React button in the highlight actions toolbar',
	},
	reactLabel: {
		id: 'experiment-inline-reactions.inline-reaction.label',
		defaultMessage: 'React',
		description: 'Label for the React button in the highlight actions toolbar',
	},
});

export const InlineReactionAction: FC = () => {
	const { formatMessage } = useIntl();
	const { triggerOpen } = useInlineReactionActions();

	return (
		<ToolbarTooltip content={formatMessage(messages.reactTooltip)}>
			<ToolbarButtonGroup>
				<ToolbarButton
					iconBefore={<EmojiAddIcon label="" size="small" />}
					testId="highlight-actions-react"
					onClick={triggerOpen}
				>
					<FormattedMessage {...messages.reactLabel} />
				</ToolbarButton>
			</ToolbarButtonGroup>
		</ToolbarTooltip>
	);
};
